import { DragScrolling } from '../../../src/scripts/components/controls/drag-scroll.js'

export class ImageZoom {
  constructor (elem) {
    this.elem = elem
    this.image = this.elem.querySelector('[data-image-zoom-image]')
    this.zoomImageUrl = this.image.getAttribute('data-image-zoom-image-src')

    if (this.zoomImageUrl === null) {
      return
    }

    this.container = this.elem.querySelector('[data-image-zoom-container-wrap]')
    this.imageContainer = this.elem.querySelector('[data-image-zoom-container]')
    this.scrolling = new DragScrolling(this.imageContainer, false)
    this.zoomInButton = this.elem.querySelector('[data-image-zoom-in]')
    this.zoomOutButton = this.elem.querySelector('[data-image-zoom-out]')
    this.containerWidth = null
    this.containerHeight = null
    this.imageWidth = null
    this.imageHeight = null
    this.imageLoaded = false
    this.zoomLevel = 0
    this.imageHasSwapped = false
    this.disableZoom()

    this.zoomInButton.addEventListener('click', (event) => {
      if (this.zoomLevel < 10) {
        this.zoomLevel += 1
      }

      if (!this.imageHasSwapped) {
        this.toggleImageSource()
        this.imageHasSwapped = true
      }

      this.disableZoom()
      this.zoomImage()
    })

    this.zoomOutButton.addEventListener('click', (event) => {
      if (this.zoomLevel > 0) {
        this.zoomLevel -= 1
      }

      if (!this.imageHasSwapped) {
        this.toggleImageSource()
        this.imageHasSwapped = true
      }

      this.disableZoom()
      this.zoomImage()

      if (this.zoomLevel === 0) {
        this.resetPositionImage()
      }
    })

    this.image.addEventListener('load', () => {
      if (this.imageLoaded) {
        return
      }

      this.disableZoom()
      this.loadImage()
      this.setPositionImage()
    })
  }

  toggleImageSource () {
    const currentSrc = this.image.getAttribute('src')
    const newSrc = currentSrc === this.zoomImageUrl ? this.image.getAttribute('data-original-src') : this.zoomImageUrl
    this.image.setAttribute('src', newSrc)
    this.image.setAttribute('srcset', '')
  }

  getOffset (el) {
    const rect = el.getBoundingClientRect()
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    }
  }

  loadImage () {
    this.imageWidth = this.image.offsetWidth
    this.imageHeight = this.image.offsetHeight

    this.containerWidth = this.imageContainer.offsetWidth
    this.containerHeight = this.imageContainer.offsetHeight
    this.imageLoaded = true
  }

  setPositionImage () {
    this.image.style.top = `${
      this.containerHeight / 2 - this.imageHeight / 2
    }px`
    this.image.style.left = `${this.containerWidth / 2 - this.imageWidth / 2}px`
  }

  resetPositionImage () {
    this.image.style.top = '0px'
    this.image.style.left = '0px'
  }

  zoomImage () {
    const scaleFactor = (this.zoomLevel / 10) + 1
    this.image.style.width = `${this.imageWidth * scaleFactor}px`
    this.image.style.height = `${this.imageHeight * scaleFactor}px`
  }

  disableZoom () {
    this.zoomInButton.style.background =
      this.zoomLevel === 10 ? 'rgba(255, 255, 255, .8)' : '#fff'

    if (this.zoomLevel === 0) {
      this.zoomOutButton.setAttribute('disabled', 'disabled')
    } else {
      this.zoomOutButton.removeAttribute('disabled')
    }

    this.zoomOutButton.style.background =
      this.zoomLevel === 0 ? 'rgba(255, 255, 255, .8)' : '#fff'

    if (this.zoomLevel === 10) {
      this.zoomInButton.setAttribute('disabled', 'disabled')
    } else {
      this.zoomInButton.removeAttribute('disabled')
    }
  }
}

export function setupImageZoom () {
  const elems = document.querySelectorAll('[data-image-zoom]')
  const images = []

  for (const element of elems) {
    images.push(new ImageZoom(element))
  }

  return images
}
